module.exports = __webpack_public_path__ + "img/Condenser.faf743b0.png";